
/*

 Click and touch events helpers

 */

function click_touch_init() {

    $(document).on('click.touchfocused', '.touchevents .js-touch-focused, .js-touch-focused-all', function (e) {
        var $o = $(this);
        if (!$o.hasClass('focused')) {
            if (!$o.hasClass('disable-prevent-link-clicks')) {
                e.preventDefault();
            }
            $('.js-touch-focused').not($o).not($o.closest('.js-touch-focused')).removeClass('focused');
            $o.addClass('focused');
        }
        else {
            if ($o.hasClass('js-touch-focused-toggle')) {
                $o.removeClass('focused');
            }
        }
    });

    $(document).on('click', '.touchevents .js-touch-focused a, .js-touch-focused-all a', function (e) {
        var $tf = $(this).closest('.js-touch-focused');
        if (!$tf.hasClass('focused') && !$tf.hasClass('disable-prevent-link-clicks')) {
            e.preventDefault();
        }
    });

    $(document).on('click', '*', function (e) {
        if (!$(e.target).closest('.js-touch-focused').length) {
            $('.js-touch-focused').removeClass('focused');
        }
    });

    $(document).on('click', '.js-prevent-default', function (e) {
        e.preventDefault();
    });

    $(document).on('click', '.js-stop-propagation', function (e) {
        e.stopPropagation();
    });

}



/*

Responsive design helpers

 */

function responsive_init() {
    responsive_update();
}

function responsive_update(force, no_animation) {
    if (typeof no_animation !== 'undefined' && no_animation) {
        $('body').addClass('no-transition no-animation');
    }
    if (typeof force === 'undefined') force = false;
    var ww = window.innerWidth;
    if ($('body').data('ww') != ww || force)
    {
        if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
            Blazy.revalidate();
        }
        $('[data-place]').each(function(){
            var places = $(this).data('place');
            var breakpoints = Object.keys(places).map(function(value) {
                return parseInt(value);
            }).sort(function(a,b) {
                return a - b;
            }).reverse();
            for (i in breakpoints) {
                if (window.matchMedia('(min-width: '+breakpoints[i]+'px)').matches) {
                    if ($(places[breakpoints[i]]).length)  {
                        if (!$(this).next(places[breakpoints[i]]).length) {
                            $(this).attr('data-place-breakpoint', breakpoints[i]).insertBefore(places[breakpoints[i]]);
                        }
                    }
                    break;
                }
            }
        });

        $('body').trigger('responsive-update');
        if (no_animation) {
            $('body').trigger('responsive-update-no-animation');
        }

        $('body').data('ww', ww);
    }
    if (typeof no_animation !== 'undefined' && no_animation) {
        $('body')[0].offsetHeight;
        $('body').removeClass('no-transition no-animation');
    }
}


/*

Scroll Lazy Loading

 */

function blazy_init() {

    $('.js-blazy-revalidate-on-scroll').on('scroll', function(){
        blazy_revalidate_on_scroll_delay(function(){
            if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
                Blazy.revalidate();
            }
        }, 50);
    });

    window.Blazy = new Blazy({
        offset: window.innerHeight,
        success: function(ele){
            $(ele).addClass('blazy-loaded');
            var $o = $(ele).closest('.img-to-bg');
            if ($o.length) {
                img_to_bg($o);
                $o.addClass('img-to-bg-lazy-loaded');
            }
            //console.log('Blazy', ele, 'success');
            blazy_callback(ele);
        }
        , error: function(ele, msg){
            //console.log('Blazy', ele, msg);
            blazy_callback(ele);
            if(msg === 'missing'){
                //console.log(ele, msg);
            }
            else if(msg === 'invalid'){
                //console.log(ele, msg);
            }
        }
    });

    $(window).on('resize', function(){
        blazy_revalidate_delay(function(){
            blazy_revalidate();
        }, 100);
    });

    $(document).on('shown.bs.modal', function () {
        blazy_revalidate();
    });

    $('.js-slick-slider-revalidate-image').on('init reInit setPosition', function(event){
        blazy_revalidate();
    });
}

function blazy_callback(ele) {
    var callback = $(ele).not('.blazy-callback-executed').data('src-callback');
    if (callback) {
        var callback_params = $(ele).data('src-callback-params');
        if (!callback_params) {
            callback_params = [];
        }
        var fn = getFunctionFromString(callback);
        if (typeof fn === 'function') {
            $(ele).addClass('blazy-callback-executed');
            fn.apply(ele, callback_params);
        }
    }
}

function blazy_revalidate() {
    if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
        Blazy.revalidate();
    }
}

var blazy_revalidate_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

var blazy_revalidate_on_scroll_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

// Get function from string, with or without scopes (by Nicolas Gauthier)
window.getFunctionFromString = function(string)
{
    var scope = window;
    var scopeSplit = string.split('.');
    for (i = 0; i < scopeSplit.length - 1; i++)
    {
        scope = scope[scopeSplit[i]];

        if (scope == undefined) return;
    }

    return scope[scopeSplit[scopeSplit.length - 1]];
};



/*

Set Background Image depending on img content inside it

 */

function img_to_bg($o, context) {

    if (!$('body').hasClass('img-to-bg-inited')) {

        $(window).on('resize', function(){
            delay_img_to_bg(function(){
                img_to_bg($('.img-to-bg-resp'));
            }, 100);
        });

        $('body').addClass('img-to-bg-inited');
    }

    if (typeof $o === 'undefined' || !$o) $o = $('.img-to-bg', context);
    $o.each(function () {
        var $imgtobg = $(this);
        var $img = $imgtobg.find('> img').first();
        if (!$img.length) {
            $img = $imgtobg.find('> picture img').first();
        }
        var src = '';
        if ($img.length) {
            var src = $img[0].currentSrc;
        }
        if (!src) {
            src = $img.attr('src');
        }
        if ($img.length && src) {
            $imgtobg.css('background-image', 'url("' + src + '")');
            $imgtobg.addClass('img-to-bg--inited');
        }
    });
}

var delay_img_to_bg = (function(){
    var timer = 0;
    return function(callback, ms){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
    };
})();


/*

Actions on Scroll

 */

function scroll_animations(force) {
    body_scrolled(force);
    scroll_activate_init();
}


/*

Scroll to needed objects

 */

function goto_init() {

    if (location.hash && location.hash.length) {
        try {
            var hash = location.hash.substr(1);
            if (hash) {
                var $o = $('[id="'+hash+'"]').first();
                if ($o.length) {
                    var h = $('.js-goto-offset-on-load').not('.js-goto-offset').first().outerHeight();
                    goto_object($o, 0, (h)?-1*h:0);
                    scroll_activate_init();
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    $(document).on('click', '.js-goto', function (e) {
        var href = $(this).attr('href');
        var hash = href.split('#');
        if (hash.length > 1) {
            hash = '#'+hash.pop();
            var $o = $(hash);
            if ($o.length) {
                e.preventDefault();
                var $this = $(this);
                if ($this.closest('.goto-list').length)
                {
                    $this.closest('.goto-list').find('li').removeClass('active');
                    $this.closest('li').addClass('active');
                    tabs_update_pointer($this.closest('.tabs'));
                }
                if ($this.closest('.goto-hash-change').length)
                {
                    location_hash_update($this.attr('href'));
                }
                goto_object($o, $this.data('goto-speed'), undefined, $this);
            }
        }
    });
}

function goto_object($o, speed, doffset, $trigger)
{
    if (typeof speed === 'undefined') {
        speed = 1200;
    }
    if ($o.length)
    {
        var offset = $o.offset().top;
        if (typeof doffset !== 'undefined') {
            offset += doffset;
        }
        var $offset = $('.js-goto-offset').first();
        if ($offset.length) {
            offset -= $offset.outerHeight();
        }
        if ($o.data('goto-offset-element')) {
            $($o.data('goto-offset-element')).each(function(){
                offset -= $(this).outerHeight();
            });
        }
        if ($(window).scrollTop() < offset) {
            var $offset = $('.js-goto-offset-up').first();
            if ($offset.length) {
                offset += $offset.outerHeight();
            }
        }
        goto_offset(offset, speed, $o, $trigger);
    }
}

function goto_offset(offset, speed, $o, $trigger)
{
    if (typeof speed === 'undefined') {
        speed = 700;
    }
    $('body').trigger('goto-start', [offset, speed, $o, $trigger]);
    $('html, body').stop(true, true).animate({scrollTop: offset}, speed, function(){
        $(this).trigger('goto-end', [offset, speed, $o, $trigger]);
        if ($o) {
            $o.trigger('goto-end', [offset, speed, $o, $trigger]);
        }
    });
}


/*

Scroll activate

 */

function scroll_activate_init() {

    if (!$('body').hasClass('scroll-activate-inited')) {

        $(document).on('goto-start', function(e, offset, speed, $o, $trigger){
            if ($o && $o.length && $o.closest('.js-scroll-activate-section').length) {
                scroll_activate($o);
            }
            window['scroll-activate-locked'] = true;
            delay(function(){
                // delay(function(){
                //     window['scroll-activate-locked'] = false;
                // }, 1200);
            }, 0);
        });

        $(document).on('goto-end', function(e){
            if (e.target.nodeName == 'HTML') {
                delay(function(){
                    window['scroll-activate-locked'] = false;
                    scroll_activate_init();
                }, 0);
            }
        });

        $('body').addClass('scroll-activate-inited');
    }

    var st = $(window).scrollTop();
    var dh = 0;//$('.js-goto-offset').outerHeight();
    var dw = $(window).height() / 3;
    var is_page_bottom = $('.wrap').outerHeight() - $(window).height() - st < 100;
    var $sections = $('.js-scroll-activate-section');
    var f_this = this;
    f_this.hmai = [];
    if ($sections.length && !window['scroll-activate-locked']) {
        var t_offset = 0;
        if (st > t_offset) {
            var $active = false;
            var $active_o = false;
            var index = -1;
            $sections.each(function(i){
                var $this = $(this);
                if ($this.data('scroll-activator')) {
                    $this = $($this.data('scroll-activator'));
                }
                var o_h = $this.outerHeight();
                if (!o_h && $this.data('scroll-activate-stop')) {
                    $o_s_e = $($this.data('scroll-activate-stop'));
                    o_h = $o_s_e.offset().top - $this.offset().top;
                }
                if (st + dw >= $this.offset().top - dh && st + dw < $this.offset().top + o_h - dh) {
                    index = i;
                    $active_o = $this;
                    return false;
                }
            });
            if (is_page_bottom) {
                index = $sections.length - 1;
                $active_o = $sections.last();
            }
            if ($active_o && (typeof f_this.hmai === 'undefined' || index != f_this.hmai)) {
                f_this.hmai = index;
                scroll_activate($active_o);
            }
        } else {
            f_this.hmai = -1;
            $active_o = $sections.first();
            scroll_activate($active_o);
        }
    }
}

function scroll_activate_get_section(_href) {
    if (!_href) {
        return false;
    }
    var href = _href.split('#');
    if (href[1]) {
        href = '#'+ href[1];
    }
    else {
        return false;
    }
    if (href.length < 2) {
        return false;
    }
    return $(href);
}

function scroll_activate($obj) {
    var id = $obj.attr('id');
    if (id) {
        $link = $('a[href="#'+id+'"]');
        $link.not('[data-scroll-activate-no-classes]').addClass('active').siblings().removeClass('active');
        $link.not('[data-scroll-activate-no-classes]').closest('li').addClass('active').siblings().removeClass('active').find('a').removeClass('active');
        $link.trigger('link-activated', [$obj]);
    }
    if ($obj) {
        $obj.trigger('link-activated');
    }
}

function body_scrolled(force) {
    requestAnimationFrame(function(){
        var $o = $('.js-header-on-scroll');
        if ($o.length) {
            scroll_back_header($o, force);
        }
    });
}

function scroll_back_header($o, force) {
    var h_offset = $('.js-header-start').offset().top;
    var h_height = $('.js-header-height').height();
    var y_offset = window.pageYOffset;
    this.menuScrolled = y_offset > h_offset;
    if (!this.oldScrollPosition) {
        this.menuHidden = y_offset > h_offset + h_height;
    }
    else {
        this.menuHidden = y_offset > h_offset + h_height && y_offset > this.oldScrollPosition;
    }
    if (y_offset != this.oldScrollPosition || force) {
        $o.toggleClass('header--scrolled', this.menuScrolled);
        if (this.menuHidden && !this.menuScrolledHeight) {
            $o.css('transition', 'none');
        }
        $o.toggleClass('header--hidden', this.menuHidden);
        if (this.menuHidden && !this.menuScrolledHeight) {
            $o[0].offsetHeight;
            $o.css('transition', '');
        }
        if (!this.oldScrollPosition) {
            this.menuScrolledHeight = y_offset > h_offset + h_height;
        }
        else {
            this.menuScrolledHeight = y_offset > h_offset && y_offset < this.oldScrollPosition || y_offset > h_offset + h_height && y_offset > this.oldScrollPosition;
        }
        $o.toggleClass('header--scrolled-height', this.menuScrolledHeight);
    }
    this.oldScrollPosition = y_offset;
}

function scroll_back_header_hide($o) {
    var h_offset = $('.js-header-start').offset().top;
    var h_height = $('.js-header-height').height();
    var y_offset = window.pageYOffset;
    this.menuHidden = y_offset > h_height;
    $o.toggleClass('header--hidden', this.menuHidden);
}



/*

Header Init

*/

function header_init() {

    $(document).on('click', '.js-menu-switcher', function (e) {
        e.preventDefault();
        $('.js-menu-switcher-target').toggleClass('menu-overlay-active');
        if ($('.js-menu-switcher-target').hasClass('menu-overlay-active')) {
            // if (!$('.js-menu-switcher-target').data('mousewheel.bodyscrolllock')) {
            //     $('body')[0].addEventListener('mousewheel', function(e){
            //         if ($('.js-menu-switcher-target').hasClass('menu-overlay-active')) {
            //             e.preventDefault();
            //         }
            //     }, { passive: false });
            //     $('.js-menu-switcher-target').data('mousewheel.bodyscrolllock', true);
            // }
            if (isMobile) {
                bodyScrollLock.disableBodyScroll($('.js-menu-overlay .js-menu-overlay-scroll')[0]);
            }
            setTimeout(function(){
                blazy_revalidate();
            }, 500);
        }
        else {
            if (isMobile) {
                bodyScrollLock.enableBodyScroll($('.js-menu-overlay .js-menu-overlay-scroll')[0]);
            }
        }
    });

    $(document).on('click', '.js-menu-hide', function (e) {
        e.preventDefault();
        menu_overlay_hide();
    });

    $(document).on('click', '*', function (e) {
        if (!$(e.target).closest('.js-menu-overlay, .js-menu-switcher').length) {
            if ($('.js-menu-switcher-target').hasClass('menu-overlay-active')) {
                menu_overlay_hide();
            }
        }
    });

    // $(document).on('touchmove', '.js-menu-overlay', function (e) {
    //     e.stopPropagation();
    // });
    //
    // $(window).on('scroll', function (e) {
    //     if ($('html').hasClass('menu-overlay-active')) {
    //         menu_overlay_hide();
    //     }
    // });

}

function menu_overlay_hide() {
    $('.js-menu-switcher-target').removeClass('menu-overlay-active');
    if (isMobile) {
        bodyScrollLock.enableBodyScroll($('.js-menu-overlay .js-menu-overlay-scroll')[0]);
    }
}



/*

Fix buggy 100vh behaviour on mobiles

 */


var fix_100vh_w = -1;
var fix_100vh_h = -1;

function fix_100vh_init() {
    if (!Modernizr.touchevents) return;

    fix_100vh();
    $('body').data('fix_100vh_ww', $(window).width());

    $(window).on('resize', function (e) {
        if (fix_100vh_w != window.innerWidth || fix_100vh_h != window.innerHeight) {
            fix_100vh();
        }
        fix_100vh_w = window.innerWidth;
        fix_100vh_h = window.innerHeight;
    });
}

function fix_100vh() {
    var h = window.innerHeight;
    $('.js-fix-100vh').each(function(){
        $(this).css('height', h);
    });
    $('.js-fix-100vh-minus-header').each(function(){
        $(this).css('height', h - $('.header + .header-replace')[0].offsetHeight);
    });
    $('.js-fix-100vh-min').each(function(){
        $(this).css('min-height', h);
    });
    $('.js-fix-100vh-max').each(function(){
        $(this).css('max-height', h);
    });
}





/*

Hide/Show blocks

 */

function toggle_element_init()
{
    $(document).on('click click-pseudo change toggle-hide', '.js-toggle-element, .js-show-element, .js-hide-element', function (e) {
        if ($(this).is('a')) e.preventDefault();
        if ((e.type == 'click' || e.type == 'click-pseudo') && $(this).is(':checkbox,:radio')) {
            return true;
        }
        var $o = $();
        if ($(this).attr('href') && $(this).attr('href').length > 1 && $(this).attr('href').slice(0, 1) === '#') {
            $o = $($(this).attr('href'));
        }
        if (!$o.length && $(this).data('selector')) {
            $o = $($(this).data('selector'));
        }
        if (!$o.length) {
            $o = $(this).closest('.js-toggle-element-wrapper').find('.js-toggle-element-target');
        }
        if (!$o.length) {
            $o = $(this).closest('.js-toggle-element-wrapper');
        }
        var restore_scroll = $(this).data('toggle-restore-scroll-position');
        if (restore_scroll) {
            var scroll_pos = $(window).scrollTop();
            var $scroll_relative = $(this);
            var scroll_relative = $(this).data('toggle-restore-scroll-relative');
            if (scroll_relative) {
                $scroll_relative = $(scroll_relative);
            }
            var offset_pos = parseInt($scroll_relative.offset().top, 10);
        }
        var class_name = 'hidden';
        if ($(this).data('toggle-class')) {
            class_name = $(this).data('toggle-class');
        }
        var element_class_name = 'active';
        if ($(this).data('toggle-element-class')) {
            element_class_name = $(this).data('toggle-element-class');
        }
        toggle_element_close_all($o);
        $o.data('toggle-element', $(this));
        var change_label = false;
        if (($(this).hasClass('js-toggle-element') && e.type != 'toggle-hide') || (e.type == 'toggle-hide' && $o.hasClass(element_class_name))) {
            change_label = true;
            if ($(this).is(':checkbox,:radio')) {
                if (e.type == 'change') {
                    if ($(this).data('toggle-reverse')) {
                        $o.toggleClass(class_name, $(this).prop('checked'));
                    }
                    else {
                        $o.toggleClass(class_name, !$(this).prop('checked'));
                    }
                }
            }
            else {
                $(this).toggleClass(element_class_name);
                $o.toggleClass(class_name);
            }
            $o.data('toggle-class', class_name);
            $o.data('toggle-element-class', element_class_name);
            $o.trigger('toggle-element');
        }
        if ($(this).data('toggle-close-other') && e.type != 'toggle-hide') {
            var group = $(this).data('toggle-group');
            $('.js-toggle-element, .js-show-element').not(this).filter('[data-toggle-group="'+group+'"]').each(function(){
                $(this).trigger('toggle-hide');
            });
        }
        if ($(this).hasClass('js-show-element')) {
            $o_s = $($(this).data('selector-show'));
            if ($o_s.length) {
                $o = $o_s;
            }
            if (!$(this).hasClass(element_class_name)) change_label = true;
            $(this).addClass(element_class_name);
            $o.toggleClass(class_name, !!$(this).data('toggle-reverse'));
            $o.trigger('show-element');
        }
        if ($(this).hasClass('js-hide-element')) {
            $o_h = $($(this).data('selector-hide'));
            if ($o_h.length) {
                $o = $o_h;
            }
            if ($(this).hasClass(element_class_name)) change_label = true;
            $(this).addClass(element_class_name);
            $o.toggleClass(class_name, !$(this).data('toggle-reverse'));
            $o.trigger('hide-element');
        }
        if (change_label && $(this).data('toggle-change-label')) {
            var label = $(this).html();
            $(this).html($(this).attr('data-toggle-change-label'));
            $(this).attr('data-toggle-change-label', label);
        }
        var $siblings = $();
        if ($(this).data('toggle-siblings-selector')) {
            $siblings = $(this).closest($(this).data('toggle-siblings-selector')).siblings();
        }
        if ($(this).data('toggle-current-selector')) {
            $siblings = $siblings.find($(this).data('toggle-current-selector'));
        }
        if ($siblings.length) {
            $siblings.removeClass(element_class_name);
        }
        if (restore_scroll) {
            var scroll_pos_new = $(window).scrollTop();
            var offset_pos_new = parseInt($scroll_relative.offset().top, 10);
            $(window).scrollTop(offset_pos_new - (offset_pos - scroll_pos));
        }
    });

    $(document).on('toggle-element show-element', function (e) {
        if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
            Blazy.revalidate();
        }
    });

    $(document).on('click', '*', function (e) {
        var $telement = $(e.target).closest('.js-toggle-element');
        if (!$telement.length && !$(e.target).closest('.js-toggle-element-target').length) {
            toggle_element_close_all();
        }
    });
}

function toggle_element_close_all($except) {
    if (!$except || !$except.length) {
        $except = $();
    }
    $('.js-toggle-element-target[data-toggle-element-close-on-blur]').not($except).each(function(){
        var classname = $(this).data('toggle-class');
        if (!classname) classname = 'hidden';
        $(this).removeClass(classname);
        $(this).trigger('toggle-element');
        if ($(this).data('toggle-element')) {
            $($(this).data('toggle-element')).removeClass($(this).data('toggle-element-class'));
        }
    });
}

var toggle_element_close_on_blur_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();




function misc_init() {

    $(document).on('link-activated', '.js-goto-section', function (e) {
        var $section = $(this);
        var id = $section.attr('id');
        if ($section.data('section-id')) {
            id = $section.data('section-id');
        }
        var $section_next = $();
        if ($section.hasClass('js-goto-section')) {
            var next = false;
            $('.js-goto-section').each(function(){
                if (next) {
                    $section_next = $(this);
                    return false;
                }
                if ($(this).is($section)) {
                    next = true;
                }
            });
        }
        var is_section_next = $section_next && $section_next.length;
        if (is_section_next) {
            var old_name = $('.js-progress-next-title').text();
            var new_name = $section_next.data('section-name');
            if (old_name != new_name) {
                $('.js-progress-next-title').text(new_name);
            }
            var next_id = $section_next.attr('id');
            if ($section_next.data('section-id')) {
                next_id = $section_next.data('section-id');
            }
            $('.js-progress-next-link').attr('href', '#'+next_id);
            $('.js-progress-next').addClass('active');
        }
        else {
            $('.js-progress-next-link').attr('href', '#');
            $('.js-progress-next').removeClass('active');
        }

        var $menus = $('.js-scroll-activate.js-tabs-fixed-center');
        $menus.each(function(){
            if (!$(this).data('link-clicked')) {
                progress_link_activate($(this), id, true);
            }
        });
    });

    $(document).on('goto-start', function(e, offset, speed, $o, $trigger){
        var id = $o.attr('id');
        var is_bullet_menu = false;
        if ($trigger && $trigger.length) {
            is_bullet_menu = $trigger.closest('.js-scroll-activate').hasClass('js-tabs-fixed-center');
        }
        var $menu = $('.js-scroll-activate.js-tabs-fixed-center');
        $menu.data('link-clicked', true);
        progress_link_activate($menu, id, (is_bullet_menu)?false:true);
        progress_link_activate_delay(function(){
            $menu.data('link-clicked', false);
        }, 1500);
    });


    $(document).on('fancybox-after-load', function(e, a, b){
        $('.js-pause-on-fancybox').each(function(){
            if (!this.paused) {
                this.pause();
            }
        });
        if (a.$trigger) {
            var href = a.$trigger.attr('href').replace(/^\//, '');
            var $gallery = $('.swiper-slider--gallery');
            var $gallery_c = $gallery.find('.swiper-container');
            if ($gallery.length) {
                $gallery.addClass('pointer-events-auto').closest('.fancybox-content').addClass('pointer-events-none');
            }
            $gallery_c.on('init init-fake', function(){
                var $this = $(this);
                $this.find('.swiper-slide img').each(function(i){
                    if (href == $(this).attr('src') || href == $(this).attr('data-src')) {
                        if ($this.length && $this[0].swiper) {
                            $this[0].swiper.slideTo(i);
                        }
                    }
                });
            }).trigger('init-fake');
        }
    });

    $(document).on('fancybox-after-close', function(e){
        $('.js-pause-on-fancybox').each(function(){
            if (this.paused) {
                this.play();
            }
        });
    });

    document.addEventListener('wheel', function(event){
        if(document.activeElement.type === 'number'){
            document.activeElement.blur();
        }
    });

    jQuery.easing['jswing'] = jQuery.easing['swing'];
    jQuery.extend( jQuery.easing,
        {
            def: 'easeOutQuad',
            swing: function (x, t, b, c, d) {
                //alert(jQuery.easing.default);
                return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
            },
            easeInQuad: function (x, t, b, c, d) {
                return c*(t/=d)*t + b;
            },
            easeOutQuad: function (x, t, b, c, d) {
                return -c *(t/=d)*(t-2) + b;
            },
            easeInOutQuad: function (x, t, b, c, d) {
                if ((t/=d/2) < 1) return c/2*t*t + b;
                return -c/2 * ((--t)*(t-2) - 1) + b;
            },
            easeInCubic: function (x, t, b, c, d) {
                return c*(t/=d)*t*t + b;
            },
            easeOutCubic: function (x, t, b, c, d) {
                return c*((t=t/d-1)*t*t + 1) + b;
            },
            easeInOutCubic: function (x, t, b, c, d) {
                if ((t/=d/2) < 1) return c/2*t*t*t + b;
                return c/2*((t-=2)*t*t + 2) + b;
            },
        });

    $(document).on('changing.spinner', '.js-reactor-quantity-set', function (e) {
        var value = $(this).val();
        $('.js-reactor-quantity-result').each(function(){
            var $this = $(this);
            var formula = $(this).data('reactor-formula');
            var result = 0;
            if (!formula) {
                formula = '{x}';
            }
            formula = formula.replace('{x}', value).replace(/[^\d\-\.\(\)\+\*\/]/, '');
            result = eval(formula);
            result = Math.ceil(result);
            // if ($(this).data('reactor-formula-round')) {
            //     result = Math.round(result);
            // }
            // if ($(this).data('reactor-formula-ceil')) {
            //     result = Math.ceil(result);
            // }
            var counter = $(this).text()*1;
            $({ Counter: counter }).animate({ Counter: result }, {
                duration: 1000,
                easing: 'easeOutCubic',
                step: function () {
                    $this.text(Math.ceil(this.Counter));
                }
            });
            //$(this).text(result);
        });
    });

}

var progress_link_activate_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

function progress_link_activate($menu, id, trigger) {
    if ($menu.data('active-id') != id) {
        var $link = $menu.find('a[href="#'+id+'"]');
        if (trigger) {
            $link.trigger('click-fixed-center');
        }
        var $item = $link.parent();
        var $items = $item.siblings().add($item);
        $items.removeClass('active active-prev active-prev2 active-prev3 active-prev4 active-next active-next2 active-next3 active-next4');
        $item.addClass('active');
        $item.prev().addClass('active-prev').prev().addClass('active-prev2').prev().addClass('active-prev3').prev().addClass('active-prev4');
        $item.next().addClass('active-next').next().addClass('active-next2').next().addClass('active-next3').next().addClass('active-next4');
    }
    $menu.data('active-id', id);
}



function iloader_init() {
    // bodyScrollLock.disableBodyScroll($('.js-iloader')[0]);
    // $('body').css('overflow', 'auto');
    $("body").removeClass("no-transition");
    window.addEventListener('load', function(){
        setTimeout(function(){
            $('.js-iloader').removeClass('active');
            $('.js-iloader-container').addClass('active');
        }, 0);
        //bodyScrollLock.enableBodyScroll($('.js-iloader')[0]);
    }, false);
}



function gsap_init() {

    var triggers = ScrollTrigger.getAll();
    triggers.forEach( function(trigger) {
        trigger.kill();
    });


    /**
     *
     * H E R O
     *
     * */

    var tl_hero_title = gsap.timeline({
        scrollTrigger: {
            trigger: '.js-gsap-hero-title-trigger',
            start: 'top top',
            end: 'bottom top',
            scrub: true,
        }
    });
    //tl_hero_title.to('.js-gsap-hero-title-inner', {scale: (isWide || true)?1/2:1/6, y: (isWide || true)?'-20vh':60, x: (isWide || true)?0:0, opacity: 0, duration: 1});
    tl_hero_title.to('.js-gsap-hero-title-inner', {scale: 1/2, y: '-20vh', opacity: 0});

    var tl_hero_subtitle = gsap.timeline({
        scrollTrigger: {
            trigger: '.js-gsap-hero-title-trigger',
            start: 'top top',
            end: 'bottom top',
            scrub: true,
        }
    });
    tl_hero_subtitle.to('.js-gsap-hero-subtitle-inner', {scale: 1/2, y: '-20vh', opacity: 0});

    // var tl_hero_description = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: '.js-gsap-hero-title-trigger',
    //         start: 'top top',
    //         end: 'bottom top',
    //         scrub: true,
    //     }
    // });
    // tl_hero_description.to('.js-gsap-hero-description-inner', {scale: 1/2, y: '-20vh', opacity: 0});

    var tl_logo_title = gsap.timeline({
        scrollTrigger: {
            trigger: '.js-gsap-hero-title-trigger',
            start: 'top top',
            end: 'bottom top',
            scrub: true,
        }
    });
    $('.js-gsap-logo-title').css({opacity: 0});
    tl_logo_title.to('.js-gsap-logo-title', {opacity: 1});
    tl_hero_title.to('.js-gsap-hero-title-inner', {scale: 1/2, y: '-20vh', opacity: 0});

    var tl_hero_more_line = gsap.timeline({
        scrollTrigger: {
            trigger: '.js-gsap-video-trigger',
            start: 'top top',
            end: 'bottom top',
            scrub: true,
        }
    });
    tl_logo_title.to('.js-gsap-hero-more-line', {scaleX: 0});

    ScrollTrigger.create({
        trigger: '.js-gsap-hero-title-place',
        start: 'top top',
        end: '+=999999999999',
        scrub: true,
        // onToggle: function(self){
        //     $('.js-gsap-hero-title').toggleClass('fixed', (isWide || true)?false:self.isActive);
        // }
    });

    var tl_hero_video = gsap.timeline({
        scrollTrigger: {
            trigger: '.js-gsap-video-trigger',
            start: 'top top',
            end: 'bottom top',
            scrub: true
        }
    });

    var video_width = isMobile?720:1470;
    var video_height = isMobile?584:1190;
    var video_width_on_bottom = isMobile?288:602;
    var video_height_on_bottom = isMobile?332:695;

    tl_hero_video.to('.js-gsap-video-crop', 1, {
        scale: video_height_on_bottom/video_height,
        y: function(){
            return $('.js-gsap-about-container').offset().top - $('.js-gsap-video-inner').offset().top - (isMobile?500:610)*$('.js-gsap-video-inner').height()/video_height;
        },
        x: '-='+(isMobile?20:100)/20+'rem'
    }, 0);
    tl_hero_video.to('.js-gsap-video-figure', 0.7, {scaleX: video_height/video_width*(video_width_on_bottom/video_height_on_bottom)}, 0);
    tl_hero_video.to('.js-gsap-video-figure-inner', 0.7, {scaleX: 1/(video_height/video_width*(video_width_on_bottom/video_height_on_bottom))}, 0);
    tl_hero_video.to('.js-gsap-video-symbol', 0.7, {x: '+='+((isMobile?(35*100):(235*53))/video_width_on_bottom)+'%', y: '+='+((isMobile?(70*100):(190*130))/video_height_on_bottom)+'%'}, 0.5);



    /**
     *
     * A B O U T
     *
     * */

    var about_trigger_params = {
        trigger: '.js-gsap-about-trigger',
        start: 'center bottom',
        end: 'center top',
        scrub: true,
    };

    TweenLite.set('.js-gsap-summary', { opacity: 0, scale: 0.8, y: (isMobile?-5:-10) + 'vh' });
    var tl_about = gsap.timeline({
        scrollTrigger: about_trigger_params
    });
    tl_about.to('.js-gsap-summary', 1, { opacity: 1, scale: 1, y: 0});
    tl_about.to('.js-gsap-summary', 0.5, { opacity: 1, scale: 1, y: 0});
    tl_about.to('.js-gsap-summary', 1, {opacity: 0, scale: 0.8, y: (isMobile?5:10) + 'vh'});

    var tl_about_video_figure = gsap.timeline({
        scrollTrigger: about_trigger_params
    });
    tl_about_video_figure.to('.js-gsap-video-figure', 1, { });
    tl_about_video_figure.to('.js-gsap-video-figure', 0.5, { });
    tl_about_video_figure.to('.js-gsap-video-figure', 1, {opacity: 0, scale: (isMobile?0.5:0.5), y: '-=' + (isMobile?7:10) + 'vh'});

    var tl_about_video_symbol = gsap.timeline({
        scrollTrigger: about_trigger_params
    });
    tl_about_video_symbol.to('.js-gsap-video-symbol', 1, { });
    tl_about_video_symbol.to('.js-gsap-video-symbol', 0.5, { });
    tl_about_video_symbol.to('.js-gsap-video-symbol', 1, {scale: 1.3});

    var tl_about_video_symbol_inner = gsap.timeline({
        scrollTrigger: about_trigger_params
    });
    tl_about_video_symbol_inner.to('.js-gsap-video-symbol-inner', 1, { });
    tl_about_video_symbol_inner.to('.js-gsap-video-symbol-inner', 0.5, { });
    tl_about_video_symbol_inner.to('.js-gsap-video-symbol-inner', 1, {x: '-='+(isMobile?(-150/20)+'rem':(280/20)+'rem'), y: '+='+(isMobile?(320/20)+'rem':(40/20)+'rem')});




    /**
     *
     * S U S T A I N A B I L I T Y
     *
     * */

    var sus_trigger_params = {
        trigger: '.js-gsap-sustainability-trigger',
        start: 'center bottom',
        end: 'center top',
        scrub: true,
    };

    TweenLite.set('.js-gsap-sustainability-title', { transformOrigin: '0 100%', opacity: 0, scale: 0.8, y: (isMobile?-5:-10) + 'vh' });
    var tl_sus_title = gsap.timeline({
        scrollTrigger: sus_trigger_params
    });
    tl_sus_title.to('.js-gsap-sustainability-title', 1, { opacity: 1, scale: 1, y: 0});
    tl_sus_title.to('.js-gsap-sustainability-title', 0.5, { opacity: 1, scale: 1, y: 0});
    tl_sus_title.to('.js-gsap-sustainability-title', 1, {opacity: 0, scale: 0.8, y: (isMobile?5:5) + 'vh'});


    TweenLite.set('.js-gsap-sustainability-summary', { transformOrigin: '0 100%', opacity: 0, y: isMobile?(100/20+'rem'):(200/20+'rem') });
    var tl_sus_summary = gsap.timeline({
        scrollTrigger: sus_trigger_params
    });
    tl_sus_summary.to('.js-gsap-sustainability-summary', 1, {opacity: 1, y: 0, x: 0});
    tl_sus_summary.to('.js-gsap-sustainability-summary', 0.5, {opacity: 1, y: 0});
    tl_sus_summary.to('.js-gsap-sustainability-summary', 1, {opacity: 0, scale: 0.9, y: (isMobile?5:10) + 'vh'});


    // var tl_about_video_figure = gsap.timeline({
    //     scrollTrigger: about_trigger_params
    // });
    // tl_about_video_figure.to('.js-gsap-video-figure', 1, { });
    // tl_about_video_figure.to('.js-gsap-video-figure', 0.5, { });
    // tl_about_video_figure.to('.js-gsap-video-figure', 1, {opacity: 0, scale: 0.5});
    //
    // var tl_about_video_symbol = gsap.timeline({
    //     scrollTrigger: about_trigger_params
    // });
    // tl_about_video_symbol.to('.js-gsap-video-symbol', 1, { });
    // tl_about_video_symbol.to('.js-gsap-video-symbol', 0.5, { });
    // tl_about_video_symbol.to('.js-gsap-video-symbol', 1, {scale: 1.3});
    //
    TweenLite.set('.js-gsap-sustainability-image-inner', { scale: 0.7, opacity: 0, x: 20*1600/100/20 + 'rem', y: (isMobile?25 + 'vh':-25 + 'vh') });
    var tl_sus_image_inner = gsap.timeline({
        scrollTrigger: sus_trigger_params
    });
    tl_sus_image_inner.to('.js-gsap-sustainability-image-inner', 1, { scale: 1, opacity: 1, x: 0, y: 0 });
    tl_sus_image_inner.to('.js-gsap-sustainability-image-inner', 0.5, { scale: 1 });
    tl_sus_image_inner.to('.js-gsap-sustainability-image-inner', 1, {  });

    var tl_sus_figure = gsap.timeline({
        scrollTrigger: sus_trigger_params
    });
    tl_sus_figure.to('.js-gsap-sustainability-image-figure', 1, { });
    tl_sus_figure.to('.js-gsap-sustainability-image-figure', 1.5, {scale: 425/395, x: '+='+(30/20)+'rem', y: '+='+(20/900*100)+'vh'});

    TweenLite.set('.js-gsap-sustainability-image-symbol', { scale: 1, x: '-=' + 30 + '%' });
    var tl_sus_image_symbol = gsap.timeline({
        scrollTrigger: sus_trigger_params
    });
    tl_sus_image_symbol.to('.js-gsap-sustainability-image-symbol', 1, { scale: 1, x: 0 });
    tl_sus_image_symbol.to('.js-gsap-sustainability-image-symbol', 0.5, { scale: 1 });
    tl_sus_image_symbol.to('.js-gsap-sustainability-image-symbol', 1, {/* y: '+=' + 100 + 'vh' */});



    /**
     *
     * V I S I O N
     *
     * */

    var vision_trigger_params = {
        trigger: '.js-gsap-vision-trigger',
        start: 'center bottom',
        end: 'center top',
        scrub: true,
    };

    var vision_trigger_params2 = {
        trigger: '.js-gsap-vision-trigger',
        start: 'center 140%',
        end: 'center top',
        scrub: true,
    };

    var vision_trigger_params3 = {
        trigger: '.js-gsap-vision-trigger',
        start: 'center 140%',
        end: 'center 50%',
        scrub: true,
    };

    TweenLite.set('.js-gsap-vision-title', { transformOrigin: '0 100%', opacity: 0, scale: 0.8, y: (isMobile?-5:-10) + 'vh' });
    var tl_vision_title = gsap.timeline({
        scrollTrigger: vision_trigger_params
    });
    tl_vision_title.to('.js-gsap-vision-title', 1, { opacity: 1, scale: 1, y: 0});
    tl_vision_title.to('.js-gsap-vision-title', 0.5, { opacity: 1, scale: 1, y: 0});
    tl_vision_title.to('.js-gsap-vision-title', 1, {opacity: 0, scale: 0.8, y: (isMobile?5:5) + 'vh'});


    TweenLite.set('.js-gsap-vision-summary', { transformOrigin: '0 100%', opacity: 0, y: isMobile?(100/20+'rem'):(200/20+'rem') });
    var tl_vision_summary = gsap.timeline({
        scrollTrigger: vision_trigger_params
    });
    tl_vision_summary.to('.js-gsap-vision-summary', 1, {opacity: 1, y: 0, x: 0});
    tl_vision_summary.to('.js-gsap-vision-summary', 0.5, {opacity: 1, y: 0});
    tl_vision_summary.to('.js-gsap-vision-summary', 1, {opacity: 0, scale: 0.9, y: (isMobile?5:10) + 'vh'});

    // TweenLite.set('.js-gsap-vision-img', { opacity: 0, scale: 1.2 });
    // var tl_vision_img = gsap.timeline({
    //     scrollTrigger: vision_trigger_params2
    // });
    // tl_vision_img.to('.js-gsap-vision-img', 1, { opacity: 1, scale: 1 });
    // tl_vision_img.to('.js-gsap-vision-img', 0.5, {  });
    // tl_vision_img.to('.js-gsap-vision-img', 1, {});

    // TweenLite.set('.js-gsap-sustainability-img', {  });
    // var tl_sus_img = gsap.timeline({
    //     scrollTrigger: vision_trigger_params3
    // });
    // tl_sus_img.to('.js-gsap-sustainability-img', 1, { opacity: 0 });
    // tl_sus_img.to('.js-gsap-sustainability-img', 0.5, {  });
    // tl_sus_img.to('.js-gsap-sustainability-img', 1, {});

    TweenLite.set('.js-gsap-sustainability-image-symbol', {  });
    var tl_sus_image_symbol = gsap.timeline({
        scrollTrigger: vision_trigger_params
    });
    tl_sus_image_symbol.to('.js-gsap-sustainability-image-symbol', 1.5, { scale: 660/750, x: '-=' + (isMobile?0:25*1600/100/20 + 'rem'), y: '+=' + (isMobile?160/20 + 'rem':125 * 900/100/20 + 'rem') });
    tl_sus_image_symbol.to('.js-gsap-sustainability-image-symbol', 1, { y: '-=' + (isMobile?10 * 900/100/20:10 * 900/100/20) + 'rem', scale: 0.5, opacity: 0 });


    var tl_sus_figure = gsap.timeline({
        scrollTrigger: vision_trigger_params
    });
    tl_sus_figure.to('.js-gsap-sustainability-image-figure', 1.5, { });
    tl_sus_figure.to('.js-gsap-sustainability-image-figure', 1, {opacity: 0, y: '+=' + 15 + 'vh', scale: 0.7});



    /**
     *
     * R E A C T O R
     *
     * */

    var reactor_trigger_params = {
        trigger: '.js-gsap-reactor-trigger',
        start: '35% bottom',
        end: 'center top',
        scrub: true,
    };

    var tl_reactor = gsap.timeline({
        scrollTrigger: reactor_trigger_params
    });
    TweenLite.set('.js-gsap-reactor', { opacity: 0, y: -100/20+'rem'});
    tl_reactor.to('.js-gsap-reactor', 1, {opacity: 1, y: 0, ease: 'power1.out'});
    tl_reactor.to('.js-gsap-reactor', 0.5, {});
    tl_reactor.to('.js-gsap-reactor', 1, {opacity: 0, y: (isMobile?-50:-300)/20+'rem', ease: 'power1.in'});
    // TweenLite.set('.js-gsap-reactor-more-line', { scaleX: 0});
    // tl_reactor.to('.js-gsap-reactor-more-line', 1, {scaleX: 1}, 1);
    // tl_reactor.to('.js-gsap-reactor-more-line', 1, {scaleX: 1}, 1);
    // tl_reactor.to('.js-gsap-reactor-more-line', 0.5, {});

    var tl_reactor_images = gsap.timeline({
        scrollTrigger: $.extend(true, {}, reactor_trigger_params, {
            onToggle: function (self) {
                $('.js-gsap-reactor-images').toggleClass('pointer-events-none', !self.isActive);
            }
        })
    });
    TweenLite.set('.js-gsap-reactor-images', { opacity: 0, y: -200/20+'rem'});
    tl_reactor_images.to('.js-gsap-reactor-images', 1, {opacity: 1, y: 0, ease: 'power1.out'});
    tl_reactor_images.to('.js-gsap-reactor-images', 0.5, {});
    tl_reactor_images.to('.js-gsap-reactor-images', 1, { opacity: 0, y: (isMobile?0:-100)/20+'rem', ease: 'power1.in'});

    var tl_reactor_desc = gsap.timeline({
        scrollTrigger: reactor_trigger_params
    });
    TweenLite.set('.js-gsap-reactor-desc', { opacity: 0, x: -300/20+'rem'});
    tl_reactor_desc.to('.js-gsap-reactor-desc', 1, {opacity: 1, x: 0, ease: 'power1.out'});
    tl_reactor_desc.to('.js-gsap-reactor-desc', 0.5, {});
    tl_reactor_desc.to('.js-gsap-reactor-desc', 1, {opacity: 0, y: (isMobile?-300:-100)/20+'rem', ease: 'power1.in'});

    var tl_reactor_params = gsap.timeline({
        scrollTrigger: reactor_trigger_params
    });
    TweenLite.set('.js-gsap-reactor-params', { opacity: 0, x: 300/20+'rem'});
    tl_reactor_params.to('.js-gsap-reactor-params', 1, {opacity: 1, x: 0, ease: 'power1.out'});
    tl_reactor_params.to('.js-gsap-reactor-params', 0.5, {});
    tl_reactor_params.to('.js-gsap-reactor-params', 1, {opacity: 0, y: (isMobile?-50:-100)/20+'rem', ease: 'power1.in'});

    var tl_reactor_mirror = gsap.timeline({
        scrollTrigger: reactor_trigger_params
    });
    TweenLite.set('.js-gsap-reactor-mirror', { y: 100/20+'rem', opacity: 0.5});
    tl_reactor_mirror.to('.js-gsap-reactor-mirror', 0.75, {});
    tl_reactor_mirror.to('.js-gsap-reactor-mirror', 0.75, {y: 0, opacity: 1, ease: 'power1.out'});
    tl_reactor_mirror.to('.js-gsap-reactor-mirror', 1, {y: (isMobile?30:100)/20+'rem', opacity: 0.5, ease: 'power1.in'});


    var tl_reactor_figure = gsap.timeline({
        scrollTrigger: {
            trigger: '.js-gsap-reactor-trigger',
            start: 'center 120%',
            end: 'center -20%',
            scrub: true,
        }
    });
    $('.js-gsap-reactor-figure').css({opacity: 0, transform: 'scale(0.5)'});
    tl_reactor_figure.to('.js-gsap-reactor-figure', 1, {opacity: 1, scale: 1, ease: 'power1.out'});
    tl_reactor_params.to('.js-gsap-reactor-figure', 0.5, {});
    tl_reactor_figure.to('.js-gsap-reactor-figure', 1, {y: isMobile?0:(700/100*80/20+'rem'), opacity: isMobile?0:1, scale: isMobile?0.5:(408/546), ease: 'power1.out'});

    if (!isMobile) {
        var tl_reactor_figure_path = gsap.timeline({
            scrollTrigger: {
                trigger: '.js-gsap-reactor-trigger',
                start: 'center 120%',
                end: 'center -20%',
                scrub: true,
            }
        });
        tl_reactor_figure_path.to('.js-gsap-reactor-figure-path', 1, {css: {strokeWidth: 40}, ease: 'power1.out'});
        tl_reactor_figure_path.to('.js-gsap-reactor-figure-path', 1, {css: {strokeWidth: 40*546/408}, ease: 'power1.out'});
    }

    /**
     *
     * T E C H
     *
     * */

    var tech_trigger_params = {
        trigger: '.js-gsap-tech-trigger',
        start: 'center bottom',
        end: 'center ' + ((isMobile)?'center':'top'),
        scrub: true,
    };

    var $tech_itgbs = $('.js-gsap-itgb');
    TweenLite.set('.js-gsap-itgb', { opacity: 0});

    var tl_tech_title = gsap.timeline({
        scrollTrigger: $.extend(true, {}, tech_trigger_params, {
            onUpdate: function(self) {
                var trigger_progress = self.progress;
                var piece = isMobile?1:1/2.5;
                var length = $tech_itgbs.length;
                if (trigger_progress < piece) {
                    var progress = trigger_progress / piece;
                    $tech_itgbs.each(function(i){
                        var item_progress = progress*(1 - 1/length) + progress*(length - i)/length;
                        if (isMobile) {
                            item_progress = progress;
                        }
                        TweenLite.set(this, { opacity: progress, y: 100*(1 - Math.min(1, item_progress))+'%'});
                    });
                }
                var piece2 = 1.5 / 2.5;
                if (trigger_progress > piece2) {
                    var progress = (trigger_progress - piece2) / piece2;
                    if (!isMobile) {
                        $tech_itgbs.each(function (i) {
                            var item_progress = progress * (1 - 1 / length) + progress * (length - i) / length;
                            TweenLite.set(this, {
                                opacity: (1 - progress),
                                y: -1 * 200 * Math.min(1, progress/*item_progress*/) + '%'
                            });
                        });
                    }
                    else {
                        TweenLite.set('.js-gsap-itgb', { opacity: 1});
                    }
                }
            }
        })
    });

    TweenLite.set('.js-gsap-tech-title', { opacity: 0, x: -300/20 + 'rem'});
    tl_tech_title.to('.js-gsap-tech-title', 1, {
        opacity: 1,
        x: 0,
        ease: 'power1.out',
    });
    if (!isMobile) {
        tl_tech_title.to('.js-gsap-tech-title', 0.5, {});
        tl_tech_title.to('.js-gsap-tech-title', 1, {
            opacity: 0,
            y: -350/20 + 'rem',
            ease: 'power1.out',
        });
    }

    var tl_tech_summary = gsap.timeline({
        scrollTrigger: tech_trigger_params
    });
    TweenLite.set('.js-gsap-tech-summary', { opacity: 0, x: 300/20 + 'rem'});
    tl_tech_summary.to('.js-gsap-tech-summary', 1, {opacity: 1, x: 0, ease: 'power1.out'});
    if (!isMobile) {
        tl_tech_summary.to('.js-gsap-tech-summary', 0.5, {});
        tl_tech_summary.to('.js-gsap-tech-summary', 1, {opacity: 0, y: -450/20 + 'rem', ease: 'power1.out'});
    }

    if (isMobile) {
        var tech_trigger_params_mobile = {
            trigger: '.js-gsap-tech-mobile-end-trigger',
            start: 'bottom 90%',
            end: 'bottom top',
            scrub: true,
            // markers: true
        };
        var tl_tech_container = gsap.timeline({
            scrollTrigger: tech_trigger_params_mobile
        });
        TweenLite.set('.js-gsap-tech-container', { opacity: 1/*, y: 0*/});
        tl_tech_container.to('.js-gsap-tech-container', 1, {opacity: 0/*, y: -50/20 + 'rem'*/, ease: 'power1.out'});
    }
    /**
     *
     * C O N T R O L
     *
     * */

    /**
     * In
     */
    var control_trigger_in_params = {
        trigger: '.js-gsap-control-trigger-in',
        start: 'center bottom',
        end: 'center top',
        scrub: true,
        //markers: true
    };

    var tl_control_figure_in = gsap.timeline({
        scrollTrigger: control_trigger_in_params
    });
    tl_control_figure_in.fromTo('.js-gsap-control-figure', { opacity: 0, scale: 0.3, ease: 'power1.out'}, {opacity: 1, scale: 1, ease: 'power1.out'});

    var tl_control_desc_in = gsap.timeline({
        scrollTrigger: control_trigger_in_params
    });
    tl_control_desc_in.fromTo('.js-gsap-control-desc', { opacity: 0, x: -300/20 + 'rem' }, {opacity: 1, x: 0});

    var tl_control_ctgbs_in = gsap.timeline({
        scrollTrigger: control_trigger_in_params
    });
    tl_control_ctgbs_in.fromTo('.js-gsap-control-ctgbs-wrapper', { opacity: 0, x: 300/20 + 'rem' }, {opacity: 1, x: 0});

    /**
     * Pinning
     */
    var control_trigger_pin_params = {
        trigger: '.js-gsap-control-trigger-pin',
        start: 'top top',
        end: function(){
            return 'bottom+='+(window.innerHeight - $('.js-gsap-control-section').height())+' bottom';
        },
        pin: '.js-gsap-control-section',
        //invalidateOnRefresh: true,
        scrub: true,
        //pinSpacing: false,
        //anticipatePin: 1,
        //markers: true,
    };
    var tl_control_pin = gsap.timeline({
        scrollTrigger: control_trigger_pin_params
    });

    /**
     * Horz Movement
     */
    var control_horz_shift = ($('.js-gsap-control-ctgbs').width() - 12 - $('.js-gsap-control-ctgbs-wrapper').width())*-1;
    var tl_control_horz_shift = gsap.timeline({
        scrollTrigger: $.extend(true, {}, control_trigger_pin_params, {
            start: '5% top',
            end: function(){
                return '95%+='+(window.innerHeight - $('.js-gsap-control-section').height())+' bottom';
            },
            pin: false,
            scrub: (isMobile)?0.1:true,
            markers: false,
            onUpdate: function(self) {
                var progress = self.progress;
                var $items = $('.js-gsap-ctgb');
                var x = gsap.getProperty('.js-gsap-control-ctgbs', 'x');
                $items.not('.active').css('opacity', 0.43+(1-0.43)*progress);
                if (!isMobile) {
                    TweenLite.set('.js-gsap-control-title', { opacity: 1 - /*0.8**/progress, x: x });
                }
            },
        })
    });
    tl_control_horz_shift.fromTo('.js-gsap-control-ctgbs', { x: 0 }, {x: control_horz_shift});

    /**
     * Out
     */
    var control_trigger_out_params = {
        trigger: '.js-gsap-control-trigger-out',
        start: function(){
            return 'center+='+(window.innerHeight - $('.js-gsap-control-section').height())+' bottom';
        },
        end: function(){
            return 'center top';
        },
        scrub: true,
        //markers: true,
    };

    var tl_control_figure_out = gsap.timeline({
        scrollTrigger: control_trigger_out_params
    });
    tl_control_figure_out.fromTo(".js-gsap-control-figure", {opacity: 1, x: 0}, {opacity: 0, y: -350/20+'rem', ease: 'power1.out'}); // {opacity: 1, y: 900/20+'rem', x: 195/20+'rem', ease: 'power1.out'}

    var tl_control_desc_out = gsap.timeline({
        scrollTrigger: control_trigger_out_params
    });
    tl_control_desc_out.fromTo(".js-gsap-control-desc", {opacity: 1}, {opacity: 0});

    var tl_control_ctgbs_out = gsap.timeline({
        scrollTrigger: control_trigger_out_params,
    });
    tl_control_ctgbs_out.fromTo(".js-gsap-control-ctgbs-wrapper", {opacity: 1}, {opacity: 0});




    // /**
    //  *
    //  * T E C H
    //  *
    //  * */
    //
    // var tech_trigger_params = {
    //     trigger: '.js-gsap-tech-trigger',
    //     start: 'center bottom',
    //     end: 'center ' + ((isMobile)?'center':'top'),
    //     scrub: true,
    // };
    //
    // var $tech_itgbs = $('.js-gsap-itgb');
    // TweenLite.set('.js-gsap-itgb', { opacity: 0});
    //
    // var tl_tech_title = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, tech_trigger_params, {
    //         onUpdate: function(self) {
    //             var trigger_progress = self.progress;
    //             var piece = isMobile?1:1/2.5;
    //             var length = $tech_itgbs.length;
    //             if (trigger_progress < piece) {
    //                 var progress = trigger_progress / piece;
    //                 $tech_itgbs.each(function(i){
    //                     var item_progress = progress*(1 - 1/length) + progress*(length - i)/length;
    //                     if (isMobile) {
    //                         item_progress = progress;
    //                     }
    //                     TweenLite.set(this, { opacity: progress, y: 100*(1 - Math.min(1, item_progress))+'%'});
    //                 });
    //             }
    //             var piece2 = 1.5 / 2.5;
    //             if (trigger_progress > piece2) {
    //                 var progress = (trigger_progress - piece2) / piece2;
    //                 if (!isMobile) {
    //                     $tech_itgbs.each(function (i) {
    //                         var item_progress = progress * (1 - 1 / length) + progress * (length - i) / length;
    //                         TweenLite.set(this, {
    //                             opacity: (1 - progress),
    //                             y: -1 * 200 * Math.min(1, progress/*item_progress*/) + '%'
    //                         });
    //                     });
    //                 }
    //                 else {
    //                     TweenLite.set('.js-gsap-itgb', { opacity: 1});
    //                 }
    //             }
    //         }
    //     })
    // });
    //
    // TweenLite.set('.js-gsap-tech-title', { opacity: 0, x: -300/20 + 'rem'});
    // tl_tech_title.to('.js-gsap-tech-title', 1, {
    //     opacity: 1,
    //     x: 0,
    //     ease: 'power1.out',
    // });
    // if (!isMobile) {
    //     tl_tech_title.to('.js-gsap-tech-title', 0.5, {});
    //     tl_tech_title.to('.js-gsap-tech-title', 1, {
    //         opacity: 0,
    //         y: -350/20 + 'rem',
    //         ease: 'power1.out',
    //     });
    // }
    //
    // var tl_tech_summary = gsap.timeline({
    //     scrollTrigger: tech_trigger_params
    // });
    // TweenLite.set('.js-gsap-tech-summary', { opacity: 0, x: 300/20 + 'rem'});
    // tl_tech_summary.to('.js-gsap-tech-summary', 1, {opacity: 1, x: 0, ease: 'power1.out'});
    // if (!isMobile) {
    //     tl_tech_summary.to('.js-gsap-tech-summary', 0.5, {});
    //     tl_tech_summary.to('.js-gsap-tech-summary', 1, {opacity: 0, y: -450/20 + 'rem', ease: 'power1.out'});
    // }
    //
    // if (isMobile) {
    //     var tech_trigger_params_mobile = {
    //         trigger: '.js-gsap-tech-mobile-end-trigger',
    //         start: 'bottom center',
    //         end: 'bottom top',
    //         scrub: true,
    //     };
    //     var tl_tech_container = gsap.timeline({
    //         scrollTrigger: tech_trigger_params_mobile
    //     });
    //     TweenLite.set('.js-gsap-tech-container', { opacity: 1/*, y: 0*/});
    //     tl_tech_container.to('.js-gsap-tech-container', 1, {opacity: 0/*, y: -50/20 + 'rem'*/, ease: 'power1.out'});
    // }


    /**
     *
     * S T A F F
     *
     * */

    /**
     * In
     */
    // var staff_trigger_in_params = {
    //     trigger: '.js-gsap-staff-trigger-in',
    //     start: 'center bottom',
    //     end: 'center top',
    //     scrub: true,
    //     //markers: true
    // };
    //
    // var tl_staff_title_in = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, staff_trigger_in_params, {
    //         // start: (isMobile?'33.33%':'center') + ' bottom',
    //         // end: 'center 50%',
    //     })
    // });
    // tl_staff_title_in.fromTo('.js-gsap-staff-title', { y: (isMobile?0:-100)/20 + 'rem', x: (isMobile?-300:0)/20 + 'rem', opacity: 0 }, {y: 0, x: 0, opacity: 1, ease: 'power1.out'});
    //
    // var tl_staff_figure_in = gsap.timeline({
    //     scrollTrigger: staff_trigger_in_params
    // });
    // tl_staff_figure_in.fromTo('.js-gsap-staff-figure', { opacity: 0, scale: 0.3, y: -600/20+'rem' }, {opacity: 1, scale: 1, y: 0, ease: 'power1.out'});
    // // TweenLite.set('.js-gsap-staff-figure', { opacity: 0, scale: 0.3 });
    // // tl_staff_figure.to('.js-gsap-staff-figure', 0.75, {scale: 0.6, opacity: 0, y: -600/20+'rem', ease: 'power1.out'});
    // // tl_staff_figure.to('.js-gsap-staff-figure', 1, {css: {opacity: 1, scale: 1, y: 0}, ease: 'power1.out'});
    // // tl_staff_figure.to('.js-gsap-staff-figure', 1, {css: {opacity: 1, scale: 1, y: 0}, ease: 'power1.out'});
    // // tl_staff_figure.to('.js-gsap-staff-figure', 0.75, {css: {opacity: 0, scale: 0, y: 200/20+'rem'}, ease: 'power1.out'});
    //
    // if (!isMobile) {
    //     var tl_staff_summary_in = gsap.timeline({
    //         scrollTrigger: $.extend(true, {}, staff_trigger_in_params, {
    //             // start: (isMobile?'33.33%':'center') + ' bottom',
    //             // end: 'center 50%',
    //         })
    //     });
    //     tl_staff_summary_in.fromTo('.js-gsap-staff-summary', { y: 100/20 + 'rem', ease: 'power1.out' }, {y: 0, ease: 'power1.out'});
    //
    //     var tl_staff_gallery_in = gsap.timeline({
    //         scrollTrigger: $.extend(true, {}, staff_trigger_in_params, {
    //             // start: (isMobile?'33.33%':'center') + ' bottom',
    //             // end: 'center '+(isMobile?-70:-50)+'%',
    //         })
    //     });
    //     tl_staff_gallery_in.fromTo('.js-gsap-staff-scroll', { opacity: 0, ease: 'power1.out' }, {opacity: 1, ease: 'power1.out'});
    // }
    // else {
    //     var tl_staff_staff_scroll_in = gsap.timeline({
    //         scrollTrigger: $.extend(true, {}, staff_trigger_in_params, {
    //             // start: (isMobile?'33.33%':'center') + ' bottom',
    //             // end: 'center 50%',
    //         })
    //     });
    //     tl_staff_staff_scroll_in.fromTo('.js-gsap-staff-scroll-wrapper', { x: 300/20 + 'rem', opacity: 0 }, {y: 0, x: 0, opacity: 1, ease: 'power1.out'});
    // }

    /**
     * Pinning
     */
    // TweenLite.set('.js-gsap-staff-control-figure-wrapper', { opacity: 0});
    // var staff_trigger_pin_params = {
    //     trigger: '.js-gsap-staff-trigger-pin',
    //     start: 'top top',
    //     end: function(){
    //         return 'bottom+='+(window.innerHeight - $('.js-gsap-staff-section').height())+' bottom';
    //     },
    //     pin: '.js-gsap-staff-section',
    //     //invalidateOnRefresh: true,
    //     scrub: true,
    //     //pinSpacing: false,
    //     //anticipatePin: 1,
    //     //markers: true,
    //     // onToggle: function(self){
    //     //     TweenLite.set('.js-gsap-control-figure-wrapper', { opacity: self.isActive?0:1});
    //     //     TweenLite.set('.js-gsap-staff-control-figure-wrapper', { opacity: !self.isActive?0:1});
    //     // },
    //     // onUpdate: function(self){
    //     //     var progress = self.progress;
    //     //     if (progress >= 1) {
    //     //         TweenLite.set('.js-gsap-staff-control-figure-wrapper', { opacity: 1});
    //     //     }
    //     //     //TweenLite.set('.js-gsap-control-figure-wrapper', { y: ($('.js-gsap-staff-trigger-pin').height() - $('.js-gsap-staff-section').outerHeight())*progress});
    //     // }
    // };
    // var tl_staff_pin = gsap.timeline({
    //     scrollTrigger: staff_trigger_pin_params
    // });

    /**
     * Horz Movement
     */
    // var staff_horz_shift = ($('.js-gsap-staff-scroll-inner').width() - $('.js-gsap-staff-scroll').width())*-1; // -1*($('.js-gsap-staff-scroll')[0].scrollWidth - $('.js-gsap-staff-scroll')[0].offsetWidth)*progress
    // var tl_staff_horz_shift = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, staff_trigger_pin_params, {
    //         start: '5% top',
    //         end: function(){
    //             return '95%+='+(window.innerHeight - $('.js-gsap-staff-section').height())+' bottom';
    //         },
    //         pin: false,
    //         scrub: (isMobile)?0.1:true,
    //         markers: false,
    //         onUpdate: function(self) {
    //             var progress = self.progress;
    //             if (!isMobile) {
    //                 var $slider = $('.js-staff-swiper-controller');
    //                 if ($slider.length && $slider[0].swiper) {
    //                     console.log('progress', slide_index);
    //                     progress = (progress - 0.1)/(1 - 0.2);
    //                     var count = $slider[0].swiper.slides.length;
    //                     var slide_index = Math.max(0, Math.min(count, Math.round(progress * (count - 1))));
    //                     $slider[0].swiper.slideTo(slide_index);
    //                 }
    //             }
    //         }
    //     })
    // });
    // tl_staff_horz_shift.fromTo('.js-gsap-staff-scroll-inner', { x: 0 }, {x: staff_horz_shift});
    // $('.js-staff-swiper-controller').on('init', function(){
    //     ScrollTrigger.refresh(true);
    // });

    /**
     * Out
     */
    // var staff_trigger_out_params = {
    //     trigger: '.js-gsap-staff-trigger-out',
    //     start: function(){
    //         return 'center+='+(window.innerHeight - $('.js-gsap-staff-section').height())+' bottom';
    //     },
    //     end: function(){
    //         return 'center top';
    //     },
    //     scrub: true,
    //     //markers: true,
    // };
    //
    // var tl_staff_title_out = gsap.timeline({
    //     scrollTrigger: staff_trigger_out_params
    // });
    // tl_staff_title_out.fromTo('.js-gsap-staff-title', {opacity: 1, y: 0}, {opacity: 0, y: (isMobile?50:200)/20 + 'rem'});
    //
    // var tl_staff_figure_out = gsap.timeline({
    //     scrollTrigger: staff_trigger_out_params
    // });
    // tl_staff_figure_out.fromTo('.js-gsap-staff-figure', { opacity: 1, scale: 1, y: 0 }, {opacity: 0, scale: 0.3, y: (isMobile?150:300)/20 + 'rem'});
    //
    // if (!isMobile) {
    //
    //     var tl_staff_summary_out = gsap.timeline({
    //         scrollTrigger: staff_trigger_out_params
    //     });
    //     tl_staff_summary_out.fromTo('.js-gsap-staff-summary', {opacity: 1, y: 0}, {opacity: 0, y: 250/20 + 'rem'});
    //
    //     var tl_staff_gallery_out = gsap.timeline({
    //         scrollTrigger: staff_trigger_out_params
    //     });
    //     tl_staff_gallery_out.fromTo('.js-gsap-staff-scroll', {opacity: 1, y: 0}, {opacity: 0, y: 250/20 + 'rem'});
    // }
    // else {
    //     var tl_staff_staff_scroll_out = gsap.timeline({
    //         scrollTrigger: $.extend(true, {}, staff_trigger_out_params, {
    //             // start: (isMobile?'33.33%':'center') + ' bottom',
    //             // end: 'center 50%',
    //         })
    //     });
    //     tl_staff_staff_scroll_out.fromTo('.js-gsap-staff-scroll', {opacity: 1, y: 0}, {opacity: 0, y: 100/20 + 'rem'});
    // }



    //
    // var staff_trigger_params = {
    //     trigger: '.js-gsap-staff-trigger',
    //     start: (isMobile?'35%':'35%') + ' bottom',
    //     end: 'center top',
    //     scrub: true,
    // };
    //
    // var tl_staff_figure = gsap.timeline({
    //     scrollTrigger: staff_trigger_params
    // });
    // TweenLite.set('.js-gsap-staff-figure', { opacity: 0, scale: 0.3 });
    // tl_staff_figure.to('.js-gsap-staff-figure', 0.75, {scale: 0.6, opacity: 0, y: -600/20+'rem', ease: 'power1.out'});
    // tl_staff_figure.to('.js-gsap-staff-figure', 1, {css: {opacity: 1, scale: 1, y: 0}, ease: 'power1.out'});
    // tl_staff_figure.to('.js-gsap-staff-figure', 1, {css: {opacity: 1, scale: 1, y: 0}, ease: 'power1.out'});
    // tl_staff_figure.to('.js-gsap-staff-figure', 0.75, {css: {opacity: 0, scale: 0, y: 200/20+'rem'}, ease: 'power1.out'});
    //
    // var tl_staff_swiper = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, staff_trigger_params, {
    //         start: isMobile?'25% top':'center 80%',
    //         end: 'center top',
    //         onUpdate: function(self) {
    //             var progress = self.progress;
    //             if (!isMobile) {
    //                 progress = (progress - 0.2)/(1 - 0.2);
    //             }
    //             if (!isMobile) {
    //                 var $slider = $('.js-staff-swiper-controller');
    //                 var slide_index = Math.round(progress * (3 - 1));
    //                 if ($slider.length && $slider[0].swiper) {
    //                     $slider[0].swiper.slideTo(slide_index);
    //                 }
    //             }
    //             else {
    //                 //$('.js-gsap-staff-scroll').scrollLeft($('.js-gsap-staff-scroll')[0].scrollWidth*progress);
    //                 TweenLite.set('.js-gsap-staff-scroll-inner', { x: -1*($('.js-gsap-staff-scroll')[0].scrollWidth - $('.js-gsap-staff-scroll')[0].offsetWidth)*progress });
    //                 TweenLite.set('.js-gsap-staff-scroll-wrapper', { y: 70*progress+'vw' });
    //             }
    //         }
    //     })
    // });
    //
    // var tl_staff_gallery = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, staff_trigger_params, {
    //         start: (isMobile?'33.33%':'center') + ' bottom',
    //         end: 'center '+(isMobile?-70:-50)+'%',
    //     })
    // });
    // TweenLite.set('.js-gsap-staff-scroll', { opacity: 0 });
    // tl_staff_gallery.to('.js-gsap-staff-scroll', 1, {opacity: 1, ease: 'power1.out'});
    // tl_staff_gallery.to('.js-gsap-staff-scroll', isMobile?1.2:1, {css: {opacity: 1, y: (isMobile?0:300)/20+'rem'}, ease: 'power1.out'});
    // tl_staff_gallery.to('.js-gsap-staff-scroll', isMobile?0.8:1, {css: {opacity: 0, y: (isMobile?-10+'vh':450/20+'rem')}, ease: 'power1.out'});
    //
    // var tl_staff_title = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, staff_trigger_params, {
    //         start: (isMobile?'33.33%':'center') + ' bottom',
    //         end: 'center 50%',
    //     })
    // });
    // TweenLite.set('.js-gsap-staff-title', { y: (isMobile?-50:-100)/20 + 'rem', opacity: 0 });
    // tl_staff_title.to('.js-gsap-staff-title', 1, {y: 0, opacity: 1, ease: 'power1.out'});
    //
    // var tl_staff_summary = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, staff_trigger_params, {
    //         start: (isMobile?'33.33%':'center') + ' bottom',
    //         end: 'center 50%',
    //     })
    // });
    // TweenLite.set('.js-gsap-staff-summary', { y: 100/20 + 'rem' });
    // tl_staff_summary.to('.js-gsap-staff-summary', 1, {y: 0, ease: 'power1.out'});



    /**
     *
     * I N F R A S T R U C T U R E
     *
     * */

    // var infra_trigger_params = {
    //     trigger: '.js-gsap-infra-trigger',
    //     start: 'center bottom',
    //     end: 'center '+(isMobile?-30:0)+'%',
    //     scrub: true,
    // };
    //
    // TweenLite.set('.js-gsap-infra-title', { opacity: 0, x: -300/20+'rem' });
    // var tl_infra_title = gsap.timeline({
    //     scrollTrigger: infra_trigger_params
    // });
    // tl_infra_title.to('.js-gsap-infra-title', 1, {opacity: 1, x: 0});
    // tl_infra_title.to('.js-gsap-infra-title', 0.5, {opacity: 1, x: 0});
    // tl_infra_title.to('.js-gsap-infra-title', 1, {opacity: 0/*, y: '-25vh'*/});
    //
    // TweenLite.set('.js-gsap-infra-summary', { opacity: 0, x: -450/20+'rem' });
    // var tl_infra_summary = gsap.timeline({
    //     scrollTrigger: infra_trigger_params
    // });
    // tl_infra_summary.to('.js-gsap-infra-summary', 1, {opacity: 1, x: 0});
    // tl_infra_summary.to('.js-gsap-infra-summary', 0.5, {opacity: 1, x: 0});
    // tl_infra_summary.to('.js-gsap-infra-summary', 1, {opacity: 0/*, y: '-20vh'*/});
    //
    // TweenLite.set('.js-gsap-infra-form', { opacity: 0, x: -600/20+'rem' });
    // var tl_infra_form = gsap.timeline({
    //     scrollTrigger: infra_trigger_params
    // });
    // tl_infra_form.to('.js-gsap-infra-form', 1, {opacity: 1, x: 0});
    // tl_infra_form.to('.js-gsap-infra-form', 0.5, {opacity: 1, x: 0});
    // tl_infra_form.to('.js-gsap-infra-form', 1, {opacity: 0/*, y: '-15vh'*/});
    //
    // TweenLite.set('.js-gsap-infra-layer', { css: { opacity: 0 }, y_v: 100});
    // var tl_infra_layer = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, infra_trigger_params, {
    //         onUpdate: function() {
    //             var progress = tl_infra_layer.progress();
    //             var value = gsap.getProperty('.js-gsap-infra-layer', 'y_v');
    //             var $layers = $('.js-gsap-infra-layer');
    //             $layers.each(function(){
    //                 TweenLite.set(this, { y: ((($(this).data('dir') == 'up')?-1:1)*value/20)+'rem' });
    //             });
    //         }
    //     })
    // });
    // tl_infra_layer.to('.js-gsap-infra-layer', 0.5, {opacity: 0, y_v: 100});
    // tl_infra_layer.to('.js-gsap-infra-layer', 0.5, {opacity: 1, y_v: 0});
    // tl_infra_layer.to('.js-gsap-infra-layer', 0.5, {opacity: 1, y_v: 0});
    // tl_infra_layer.to('.js-gsap-infra', 1, {opacity: 0/*, y: '-30vh'*/});
    //
    //
    // TweenLite.set('.js-gsap-infra-param', { css: { opacity: 0 }, y_v: 100});
    // TweenLite.set('.js-gsap-infra-param-tail', { css: { scaleY: 0, opacity: 0 } });
    // var tl_infra_param = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, infra_trigger_params, {
    //         onUpdate: function() {
    //             var progress = tl_infra_param.progress();
    //             var value = gsap.getProperty('.js-gsap-infra-param', 'y_v');
    //             var $params = $('.js-gsap-infra-param');
    //             var length = $params.length;
    //             $params.each(function(i){
    //                 TweenLite.set(this, { y: (-1*(length - i)/length*2*value/20)+'rem'});
    //                 var tail_val = Math.min((length - i)/value*2, 1);
    //                 TweenLite.set($(this).find('.js-gsap-infra-param-tail')[0], { css: { scaleY: tail_val, opacity: tail_val } });
    //             });
    //         }
    //     })
    // });
    // tl_infra_param.to('.js-gsap-infra-param', 0.7, {opacity: 0, y_v: 100});
    // tl_infra_param.to('.js-gsap-infra-param', 0.4, {opacity: 1, y_v: 0});
    // tl_infra_param.to('.js-gsap-infra-param', 0.3, {opacity: 1, y_v: 0});
    // tl_infra_param.to('.js-gsap-infra-param', 1, {opacity: 0/*, y: '-20vh'*/});



    /**
     *
     * C O N T A C T S
     *
     * */

    var contacts_trigger_params = {
        trigger: '.js-gsap-contacts-trigger',
        start: 'center bottom',
        end: 'center ' + ((isMobile)?'center':'top'),
        scrub: true,
    };

    $(".js-gsap-contacts-title-reveal").each(function(){
        var childSplit = new SplitText(this, {
            type: "lines",
            linesClass: "text-split-child"
        });
        var parentSplit = new SplitText(this, {
            // type: "lines",
            linesClass: "text-split-parent"
        });
        $(this).data('lines', childSplit.lines);
        if (!$(this).hasClass('active')) {
            gsap.set(childSplit.lines, {
                yPercent: 100,
            });
        }
    });

    TweenLite.set('.js-gsap-contacts-title', { opacity: 0, y: isMobile?0:(-200/20+'rem'), x: isMobile?(-300/20 + 'rem'):0 });
    var tl_contacts_title = gsap.timeline({
        scrollTrigger: $.extend(true, {}, contacts_trigger_params, {
            onToggle: function(self) {
                clearRequestInterval($('.js-gsap-contacts-title').data('revealInterval'));
                if (self.isActive) {
                    var interval = requestInterval(function(){
                        var $all = $(".js-gsap-contacts-title-reveal");
                        if ($all.length > 1) {
                            var active_index = false;
                            $all.each(function(i){
                                if ($(this).hasClass('active')) {
                                    active_index = i;
                                }
                            });

                            var $active = $all.eq(active_index);
                            var $next = $all.eq(active_index+1);
                            if (!$next.length) {
                                $next = $all.first();
                            }

                            var active_lines = $active.data('lines');
                            gsap.to(active_lines, {
                                duration: 1.5,
                                yPercent: -120,
                                ease: "power4",
                                stagger: 0.1,
                                onComplete: function(){
                                    $active.css('opacity', 0);
                                }
                            });

                            var next_lines = $next.data('lines');
                            gsap.set(next_lines, {
                                yPercent: 120,
                            });
                            $next.css('opacity', 1);
                            gsap.to(next_lines, {
                                duration: 1.5,
                                yPercent: 0,
                                ease: "power4",
                                stagger: 0.1,
                                delay: 0.3
                            });

                            $active.removeClass('active');
                            $next.addClass('active');
                        }
                    }, 3000);
                    $('.js-gsap-contacts-title').data('revealInterval', interval);
                }
            }
        })
    });
    tl_contacts_title.to('.js-gsap-contacts-title', 1, {opacity: 1, y: 0, x: 0});
    if (!isMobile) {
        tl_contacts_title.to('.js-gsap-contacts-title', 0.5, {opacity: 1, y: 0});
        tl_contacts_title.to('.js-gsap-contacts-title', 1, {opacity: 0, y: 200 / 20 + 'rem'});
    }


    TweenLite.set('.js-gsap-contacts-summary', { opacity: 0, y: isMobile?0:(100/20+'rem'), x: isMobile?(300/20 + 'rem'):0 });
    var tl_contacts_summary = gsap.timeline({
        scrollTrigger: contacts_trigger_params
    });
    tl_contacts_summary.to('.js-gsap-contacts-summary', 1, {opacity: 1, y: 0, x: 0});
    if (!isMobile) {
        tl_contacts_summary.to('.js-gsap-contacts-summary', 0.5, {opacity: 1, y: 0});
        tl_contacts_summary.to('.js-gsap-contacts-summary', 1, {opacity: 0, y: 300/20+'rem'});
    }




    TweenLite.set('.js-gsap-contacts-form', { opacity: 0, y: isMobile?(200/20+'rem'):(-100/20+'rem') });
    var tl_contacts_form = gsap.timeline({
        scrollTrigger: contacts_trigger_params
    });
    tl_contacts_form.to('.js-gsap-contacts-form', 1, {opacity: 1, y: 0});
    if (!isMobile) {
        tl_contacts_form.to('.js-gsap-contacts-form', 0.5, {opacity: 1, y: 0});
        tl_contacts_form.to('.js-gsap-contacts-form', 1, {opacity: 0, y: 200 / 20 + 'rem'});
    }

    // TweenLite.set('.js-gsap-contacts-figure', { css: { opacity: 0, scale: 0 }, y_v: 100});
    // var tl_contacts_figure = gsap.timeline({
    //     scrollTrigger: $.extend(true, {}, contacts_trigger_params, {
    //         onUpdate: function() {
    //             var progress = tl_infra_layer.progress();
    //             var value = gsap.getProperty('.js-gsap-contacts-figure', 'y_v');
    //             var $figures = $('.js-gsap-contacts-figure').not('.js-gsap-contacts-figure-rt, .js-gsap-contacts-figure-form');
    //             var length = $figures.length;
    //             $figures.each(function(i){
    //                 TweenLite.set(this, { css: { y: (-1*(length - i)/length*2*value/5)+'vh' }});
    //             });
    //         }
    //     })
    // });
    // tl_contacts_figure.to('.js-gsap-contacts-figure', 0.5, {opacity: 1, scale: 1, y_v: 0});
    // tl_contacts_figure.to('.js-gsap-contacts-figure', 0.8, {opacity: 1});
    // tl_contacts_figure.to('.js-gsap-contacts-figure', 1, {opacity: 0, scale: 1, y_v: -100});
}
